<template>
	<div>
		<div class="container">
			<div class="infoContain">
				<div>
					<ValidationObserver v-slot="{ handleSubmit }">
						<form class="infoBoxForm" @submit.prevent="handleSubmit(onClickNextBtn)">
							<div class="article">
								<div class="article-title">
									<h3>네트워킹 정보</h3>
								</div>
								<div class="middle-title">
									<div class="fs24 fw500">회사 소개</div>
								</div>
								<div class="flex mobileFlex">
									<div class="textAreaBox">
										<textarea
											v-model="signupInfo.aboutMe"
											placeholder="간략한 회사소개문구를 입력하세요."
										></textarea>
									</div>
								</div>
								<div class="middle-title">
									<div class="fs24 fw500">인재상</div>
								</div>
								<div class="flex mobileFlex">
									<div class="textAreaBox">
										<textarea
											v-model="signupInfo.idealTalent"
											placeholder="원하는 인재상을 입력하세요."
										></textarea>
									</div>
								</div>
							</div>
							<div class="article">
								<div class="article-title">
									<div class="fs24 fw500">제품 및 서비스</div>
								</div>
								<div class="middle-title">
									<h5>제품(서비스)명</h5>
								</div>
								<div class="flex mobileFlex">
									<div class="textAreaBox">
										<textarea
											v-model="signupInfo.productServiceName"
											placeholder="주요 제품(서비스)명을 입력하세요."
										></textarea>
									</div>
								</div>
								<div class="middle-title">
									<h5>제품(서비스) 설명</h5>
								</div>
								<div class="flex mobileFlex">
									<div class="textAreaBox">
										<textarea
											v-model="signupInfo.productServiceDesc"
											placeholder="제품(서비스)에 관한 간략한 설명을 입력하세요."
										></textarea>
									</div>
								</div>
							</div>

							<div class="article">
								<div class="article-title">
									<div class="fs24 fw500">나의 비즈니스</div>
								</div>
								<div class="article-explain">
									<h5>진행 중인 대표 사업을 선택 후, 해당되는 항목을 선택해 주세요.</h5>
								</div>
								<div class="flex mobileFlex">
									<div class="select-content">
										<div v-for="(relevant, index) in relevant_list" :key="index">
											<div class="checkBoxItem">
												<input
													v-model="relevant.isChecked"
													type="checkbox"
													:id="'relevantCheckbox' + relevant.value + '_' + index"
													:value="relevant.value"
												/>
												<label :for="'relevantCheckbox' + relevant.value + '_' + index">
													{{ relevant.name }}
												</label>
											</div>
											<template v-if="relevant.isChecked">
												<div class="mt-3">
													<SelectMultipleOption
														v-model="relevant.categoryIds"
														:options="relevant.sectors"
														placeholder="업종을 선택해주세요."
													></SelectMultipleOption>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>

							<div class="article">
								<div class="article-title">
									<div class="fs24 fw500">매치메이킹 희망분야</div>
								</div>
								<div class="article-explain">
									<h5>
										귀사가 관심있고 협력하고 싶은 시니어산업의 세부산업을 선택해주십시오.(복수선택
										가능)
									</h5>
								</div>
								<div class="flex mobileFlex">
									<div class="select-content">
										<div v-for="(matchmaking, index) in matchmaking_list" :key="index">
											<div class="checkBoxItem">
												<input
													v-model="matchmaking.isChecked"
													type="checkbox"
													:id="'matchmakingCheckbox' + matchmaking.value + '_' + index"
												/>
												<label :for="'matchmakingCheckbox' + matchmaking.value + '_' + index">
													{{ matchmaking.name }}
												</label>
											</div>
											<template v-if="matchmaking.isChecked">
												<div class=" mt-3">
													<SelectMultipleOption
														v-model="matchmaking.categoryIds"
														:options="matchmaking.sectors"
														placeholder="업종을 선택해주세요."
													></SelectMultipleOption>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>

							<div class="article">
								<div class="article-title">
									<div class="fs24 fw500">매치메이킹 희망활동</div>
								</div>
								<div class="article-explain">
									<h5>
										매치메이킹을 통해 도움받고자 하는 항목을 선택 후, 구체적인 내용을
										적어주십시오.(복수선택 가능)
									</h5>
								</div>

								<div class="flex mobileFlex">
									<div class="select-content">
										<div v-for="(activity, index) in hope_activity" :key="index">
											<div class="checkBoxItem">
												<input
													v-model="activity.isChecked"
													type="checkbox"
													:id="'activityCheckbox' + activity.value + '_' + index"
												/>
												<label :for="'activityCheckbox' + activity.value + '_' + index">
													{{ activity.name }}
												</label>
											</div>
											<div v-if="activity.isChecked" class="inputBox mt-3">
												<input
													v-model="activity.content"
													placeholder="도움 받고자 하는 내용을 구체적으로 입력하세요."
													type="text"
													class="input-grey"
												/>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="btnBox flex topPd">
								<button type="button" class="btnFont redborderBtn" @click="onClickBeforeBtn">
									이 전
								</button>
								<button type="submit" class="btnFont redBtn">다 음</button>
							</div>
						</form>
					</ValidationObserver>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { hopeActivity, matchmakingList, relevantList } from '@/data/constances'
import SelectMultipleOption from '@/components/formControl/SelectMultipleOption.vue'

export default {
	components: { ValidationObserver, SelectMultipleOption },
	data() {
		return {
			signupInfo: {},
			//가데이터
			relevant_list: relevantList.map((item) => ({ ...item, categoryIds: [] })),
			matchmaking_list: matchmakingList.map((item) => ({ ...item, categoryIds: [] })),
			hope_activity: hopeActivity,
		}
	},
	computed: {
		...mapGetters('join', ['getSignupForm']),
		selectedActivity() {
			return this.hope_activity
				.filter((item) => item.isChecked)
				.map((item) => ({
					activityId: item.value,
					content: item.content,
				}))
		},
		selectedRelevant() {
			return this.relevant_list
				.filter((item) => item.isChecked)
				.map((item) => ({
					categoryIds: item.categoryIds,
					categoryIndustryId: item.value,
				}))
		},
		selectedMatchmaking() {
			return this.matchmaking_list
				.filter((item) => item.isChecked)
				.map((item) => ({
					categoryIds: item.categoryIds,
					categoryIndustryId: item.value,
				}))
		},
	},
	methods: {
		...mapMutations('join', ['setCurrentTab', 'setCompletedInfo']),
		...mapActions('auth', ['signupCorp']),
		onClickNextBtn() {
			const signupInfo = {
				...this.getSignupForm,
				...this.signupInfo,
				industries1: this.selectedRelevant,
				industries2: this.selectedMatchmaking,
				activities: this.selectedActivity,
			}

			this.signupCorp(signupInfo)
				.then(() => {
					this.setCompletedInfo({
						id: signupInfo.id,
						name: signupInfo.name,
						phoneNumber: signupInfo.phone,
						companyName: signupInfo.companyName,
					})
					this.setCurrentTab(4)
				})
				.catch((error) => {
					var data = error.response.data
					switch (data.ERROR) {
						case 'ALREADY_EXIST_ID':
							this.$alert('알림', '사용중인 아이디 입니다.')
							break
						case 'ALREADY_EXIST_EMAIL':
							this.$alert('알림', '사용중인 이메일 입니다.')
							break
						case 'ALREADY_EXIST_PHONE_NUMBER':
							this.$alert('알림', '사용중인 전화번호 입니다.')
							break
						default:
							this.$alert('알림', '요청 실패')
							break
					}
				})
		},
		onClickBeforeBtn() {
			this.signupInfo = {}
			this.setCurrentTab(2)
		},
		onCheckRelevant(val) {
			if (this.selectedRelevant[val]) {
				delete this.selectedRelevant[val]
			} else {
				this.selectedRelevant[val] = {
					categoryIndustryId: val,
					categoryIds: [],
				}
			}
		},
		onCheckMatchmaking(val) {
			if (this.selectedMatchmaking[val]) {
				delete this.selectedMatchmaking[val]
			} else {
				this.selectedMatchmaking[val] = {
					categoryIndustryId: val,
					categoryIds: [],
				}
			}
		},

		onCheckActivity(val) {
			if (this.selectedActivity[val]) {
				delete this.selectedActivity[val]
			} else {
				this.selectedActivity[val] = {
					activityId: val,
					content: '',
				}
			}
		},
	},
}
</script>

<style scoped lang="scss">
.checkBoxForm ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
	@import '~bootstrap-vue/dist/bootstrap-vue.min';
}

.bspRadio ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
}

.bspSelectBox ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
	@import '~bootstrap-vue/dist/bootstrap-vue.min';
}
</style>

<style scoped lang="css">
.article {
	position: relative;
	margin-bottom: 56px;
}

.article::after {
	position: absolute;
	content: '';
	bottom: -14px;
	left: 0;
	width: 100%;
	height: 1px;
	background: #e7e7e7;
}

.textAreaBox {
	width: 100%;
	margin-bottom: 32px;
}

.textAreaBox p {
	display: none;
}

.middle-title {
	margin-bottom: 24px;
}

.textAreaBox textarea {
	width: 100%;
	background: #fdfcfc;
	border: 1px solid #e7e7e7;
	font-size: 20px;
	color: #000000;
	padding: 10px;
	min-height: 80px;
	resize: none;
	overflow: auto;
	font-family: 'Noto Sans KR';
	font-weight: 500;
}

.article-title {
	padding-bottom: 24px;
}

.select-content {
	width: 100%;
}

.select-content > div {
	margin: 18px 0;
}

.help-input {
	width: 100%;
	height: 45px;
	background: #fdfcfc;
	border: 1px solid #e7e7e7;
	padding: 11px;
	margin: 13px 0px 25px;
	font-size: 20px;
	font-weight: 500;
	color: #000000;
}

.help-input::placeholder {
	color: #7d7d7d;
}
</style>
